import * as React from 'react'
import { useState } from 'react'
import { TicketCustomFieldsProps, ColumnValue } from './types'
import CustomFieldInput from './custom_field_input'
import HiddenInputs from './hidden_inputs'
import I18n from '../../../libs/i18n'

interface Props {
  custom_fields: TicketCustomFieldsProps
}

function TicketCustomFields({ custom_fields }: Props) {
  const { columns, values: initialValues, input_name_prefix } = custom_fields
  const [values, setValues] = useState<Record<number, ColumnValue>>(initialValues)

  if (columns.length === 0) {
    return null
  }

  const handleValueChange = (columnId: number, newValue: string | number | string[] | null) => {
    setValues((prev) => ({
      ...prev,
      [columnId]: {
        ...prev[columnId],
        value: newValue,
      },
    }))
  }

  return (
    <fieldset className="fieldset ticket-custom-fields">
      <legend className="project-form-legend">
        {I18n.t('project_tickets.form.sections.custom_fields')}
      </legend>

      {columns.map((column) => (
        <CustomFieldInput
          key={column.id}
          column={column}
          value={values[column.id] || { value: null }}
          onChange={(newValue) => handleValueChange(column.id, newValue)}
        />
      ))}

      <HiddenInputs columns={columns} values={values} namePrefix={input_name_prefix} />
    </fieldset>
  )
}

export default TicketCustomFields
